<template>
  <div>
    <div class="btn-group-justify-end">
      <button class="button is-primary" @click="saveData">저장하기</button>
    </div>
    <div class="columns is-multiline">
      <div class="column is-full">
        <div class="box">
          <admin-box-item title="주문 기본 설정">
            <div class="columns is-multiline">
              <!-- 자동 배송완료 -->
              <div class="column is-full">
                <admin-form-item label="자동배송완료">
                  <lp-radio :val="value.success_delivery"
                            @onSelect="res=> value.success_delivery = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr1"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.success_delivery">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.success_delivery_day"
                         @input="e=>setNumber(e, 'success_delivery_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

              <!-- 자동 구매확정-->
              <div class="column is-full">
                <admin-form-item label="자동구매확정">
                  <lp-radio :val="value.success_purchase"
                            @onSelect="res=> value.success_purchase = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr2"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.success_purchase">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.success_purchase_day"
                         @input="e=>setNumber(e, 'success_purchase_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

              <!-- 자동 결제취소-->
              <div class="column is-full">
                <admin-form-item label="자동결제취소">
                  <lp-radio :val="value.cancel_paid"
                            @onSelect="res=> value.cancel_paid = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr3"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.cancel_paid">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.cancel_paid_day"
                         @input="e=>setNumber(e, 'cancel_paid_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

              <!-- 자동 배송지연-->
              <div class="column is-full">
                <admin-form-item label="자동 배송지연">
                  <lp-radio :val="value.delay_delivery"
                            @onSelect="res=> value.delay_delivery = res"
                            value_name="value"
                            label_name="label"
                            :data="option_arr4"></lp-radio>
                </admin-form-item>
              </div>
              <div class="column is-full" v-if="value.delay_delivery">
                <admin-form-item label="자동 주문 상태변경 일자">
                  <input class="input"
                         style="width:200px"
                         v-model="value.delay_delivery_day"
                         @input="e=>setNumber(e, 'delay_delivery_day', 3)"
                         type="number">
                </admin-form-item>
              </div>

            </div>
          </admin-box-item>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import LpRadio from "../../../../module/common/LpRadio";

  export default {
    components: {LpRadio},
    data() {
      return {
        value: {
          success_delivery: false,
          success_delivery_day: 7,
          success_purchase: false,
          success_purchase_day: 7,
          cancel_paid: false,
          cancel_paid_day: 7,
          delay_delivery: false,
          delay_delivery_day: 7
        },
        option_arr1:[
          { label: '배송중으로 주문상태 변경한 뒤 배송완료로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ],
        option_arr2:[
          { label: '배송완료로 주문상태 변경한 뒤 구매확정으로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ],
        option_arr3:[
          { label: '미입금일 경우 결제취소로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ],
        option_arr4:[
          { label: '상품준비중으로 주문 상태 변경한 뒤 구매확정으로 자동 주문상태 변경', value: true },
          { label: '사용안함', value: false }
        ]
      }
    },
    created(){
      this.getData();
    },
    methods:{
      setNumber(e, type, max_length){
        if( e.target.value.length > max_length ) this.value[type] = e.target.value.substr(0,max_length);
        else this.value[type] = e.target.value;
      },
      getData(){
        this.$axios.get('admin/commerce/order/setting').then(res=>{
          if(res.status===200){
            this.value = res.data;
          }
        })
      },
      saveData(){
        this.$axios.patch('admin/commerce/order/setting', {
          value: this.value
        }).then(res=>{
          if(res.status===200){
            this.toast('저장되었습니다.');
          }
        })
      }
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>

</style>
